import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=ed72c79e&scoped=true&"
import script from "./recruitment.vue?vue&type=script&lang=js&"
export * from "./recruitment.vue?vue&type=script&lang=js&"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=ed72c79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed72c79e",
  null
  
)

export default component.exports